import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=585fc0ee&scoped=true&"
import script from "./ActivityItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ActivityItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=585fc0ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fc0ee",
  null
  
)

export default component.exports